import { connect } from 'react-redux';
import SelectionClearer from '../../../components/Selection/Clearer';

export default connect()(SelectionClearer);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Selection/Clearer/index.tsx